"use strict";
import request from '@/utils/request';

var OSS = require("ali-oss");
var bucket = "partner-video"; //OSS Bucket
export default {
	/**
	 * 创建oss客户端对象
	 * @returns {*}
	 */
	createOssClient() {
		return new Promise((resolve, reject) => {
			const client = new OSS({
				region: "oss-cn-beijing", // 请设置成你的
				accessKeyId: "LTAIyaZc7Yl5obY2", // 请设置成你的
				accessKeySecret: "DC1gaB1798TlSEpOeSkAQWSBXa6RuY", // 请设置成你的
				bucket: bucket, // 请设置成你的
				secure: false, // 上传链接返回支持https
				timeout: 120 * 1000 // 超时时间（ms）,上传任务的时长主要取决于文件大小和网络上传速度（4G 1.5MB/s以上）
			});
			resolve(client);
		});
	},
	/**
	 * 文件上传
	 * @params option
	 */
	ossUploadFile(option) {
		const file = option.file;
		const self = this;
		return new Promise((resolve, reject) => {
			var date = new Date();
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var day = date.getDate();
				month = month < 10 ? '0' + month : month;
				day = day < 10 ? '0' + day : day;
			var extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
			var fileName = `${year}/${month}/${day}/${self.getRandomStr()}${extensionName}`;

			self.createOssClient().then(client => {
				// 异步上传，上传处理，简单上传文件
				client.put(fileName, file).then((data) => {
					if (data.res.status === 200) {
						// 确认上传结果
						request({
							url: '/Api/OssCallBack/upResult',
							method: 'post',
							data: {
								bucket: bucket,
								object: fileName,
								mimetype: file.type,
								size: file.size,
								group_code: '',
								user_id: 0,
								duration: option.duration > 0 ? option.duration : 0
							}
						}).then((res) => {
							resolve({
								errcode: 0,
								data: res
							});
						})
					} else {
						resolve({
							errcode: 1,
							errmsg: "上传失败"
						});
					}
				});
			});
		});
	},
	/**
	 * 创建随机字符串
	 * @returns {string}
	 */
	getRandomStr() {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		for (var i = 0; i < 32; i++) {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}
		return text;
	},
};
